"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributionService = void 0;
const DistributionServiceLive_1 = require("./DistributionServiceLive");
const DistributionServiceStub_1 = require("./DistributionServiceStub");
class DistributionService {
    static create(stub = false) {
        if (stub) {
            return new DistributionServiceStub_1.DistributionServiceStub();
        }
        return new DistributionServiceLive_1.DistributionServiceLive();
    }
}
exports.DistributionService = DistributionService;
//# sourceMappingURL=DistributionService.js.map